import classNames from "classnames";
import React, { ReactNode, useEffect, useState } from "react";
import { Collapse } from "react-bootstrap";
import { List } from "./list";
import SvgChevronRight from "../icons/ChevronRight";
import * as bd from "../index";
import SvgCheckBox from "../icons/CheckBox";
import SvgCheckBoxOutlineBlank from "../icons/CheckBoxOutlineBlank";
import SvgRadioButtonChecked from "../icons/RadioButtonChecked";
import SvgRadioButtonUnchecked from "../icons/RadioButtonUnchecked";

interface ListItemProps {
    variant?: "" | "text" | "button" | "menu";
    className?: string;
    alignTop?: boolean;
    icon?: ReactNode | ((expanded: boolean) => ReactNode);
    checked?: "" | true | false;
    radio?: boolean;
    primary: ReactNode;
    secondary?: ReactNode;
    inset?: boolean;
    selected?: boolean;
    compact?: boolean;
    expanded?: boolean;
    disabled?: boolean;
    caretPosition?: "none" | "start" | "end";
    controls?: any;
    expandCommand?: any;
    children?: any;
    command?: any;
    onClick?: (e: any) => any;
    onTitleClick?: (e: any) => any;
    [x: string]: any;
}

export const ListItem = ({
    variant,
    className,
    alignTop,
    icon,
    checked,
    radio,
    primary,
    secondary,
    inset,
    selected,
    compact,
    expanded,
    disabled,
    caretPosition,
    controls,
    expandCommand,
    onClick,
    onTitleClick,
    children,
    ...props
}: ListItemProps) => {
    if (!caretPosition) caretPosition = "end";
    const [isExpanded, setIsExpanded] = useState(expanded);

    useEffect(() => {
        if (expandCommand?.expandAll == true) {
            if (!isExpanded) setIsExpanded(true);
        } else if (expandCommand?.collapseAll == true) {
            if (!!isExpanded) setIsExpanded(false);
        }
    }, [expandCommand]);

    const cn = classNames("bd-list-item", className, {
        "bd-list-menu": variant === "menu",
        "bd-list-button": variant === "button",
        "bd-list-inset": inset,
        "bd-list-selected": selected,
        "bd-list-align-top": alignTop,
    });

    const clickHandler = (e) => {
        if (onClick) {
            if (onClick(e) === false) return false;
        }
        if (variant === "text") return null;
        if (disabled) return;
        setIsExpanded(!isExpanded);
    };

    if (checked === true) icon = radio ? <SvgRadioButtonChecked className="text-primary" /> : <SvgCheckBox className="text-primary" />;
    if (checked === false) icon = radio ? <SvgRadioButtonUnchecked /> : <SvgCheckBoxOutlineBlank />;

    if (children && children.length > 0) {
        if (children[0]?.type !== List) children = <List>{children}</List>;
    }

    const RenderIcon = () => {
        if (typeof icon === "function") return icon(isExpanded);
        return icon;
    };

    return (
        <li className={cn} {...props}>
            <bd.Toolbar size={compact ? "sm" : "md"} onClick={clickHandler} className={classNames({ disabled })}>
                {!!children && caretPosition == "start" && (
                    <span className="m-e-2">
                        <SvgChevronRight
                            className={classNames("transition-transform", {
                                "rotate-90": isExpanded,
                                "rtl-rotate-180": !isExpanded,
                            })}
                        />
                    </span>
                )}

                {icon && <div className={"bd-list-icon bd-list-py"}>{RenderIcon()}</div>}

                <div className="bd-list-label" onClick={onTitleClick}>
                    <div>{primary}</div>
                    {secondary && <div className="text-secondary-text">{secondary}</div>}
                </div>

                {controls}

                {!!children && caretPosition == "end" && (
                    <span className="">
                        <SvgChevronRight
                            className={classNames("transition-transform", {
                                "rotate-90": isExpanded,
                                "rtl-rotate-180": !isExpanded,
                            })}
                        />
                    </span>
                )}
            </bd.Toolbar>

            {children && (
                <Collapse in={isExpanded}>
                    <div>{children}</div>
                </Collapse>
            )}
        </li>
    );
};
